import {Promotion} from "../../domain/dtos/promotion";

export class PromotionMapper {
    static deserialize(param: any): Promotion {
        return {
            code: param.code,
            name: param.name,
            description: param.description,
            image: param.image,
            discountedPrice: param.promoPrice,
            price: param.noPromoPrice,
            startDate: new Date(param.startDate),
            endDate: new Date(param.endDate),
        }
    }
}
